import { OreSpinner } from '@edenredespana/oreneta'

const Spinner = (): JSX.Element => (
  <div className="spinner--container">
    <OreSpinner />
  </div>
)

export { Spinner }
